import React from "react";
import "./styles.css";
import { REACT_APP_URL } from "../../config";

import Button from "@mui/material/Button";
import { Link } from "react-router-dom";

const SingleProductCard = ({
  product,
  orderProducts,
  setStatus,
  handleCancleClick,
  handleAssignArchitectClick,
  isAdmin,
}) => {
  return (
    <tr>
      <td className={product?.isCancelled ? "redrow" : ""}>
        <Link
          to={`/product/${product?.singleProductId?.Collection[0]?.url}/${
            product?.singleProductId?.Urlhandle
          }?productType=${"singleProducts"}&orderId=${
            orderProducts?._id
          }&orderItemId=${product?._id}`}
        >
          <img
            src={`${REACT_APP_URL}/images/product/${product?.image}`}
            alt="img25"
            style={{ height: "15vh" }}
          />
        </Link>
      </td>
      <td className={product?.isCancelled ? "redrow" : ""}>
        <p style={{ fontSize: "17px", backgroundColor: "transparent" }}>
          {product?.singleProductId?.ProductName}
        </p>
      </td>
      <td
        className={product?.isCancelled ? "redrow" : ""}
        style={{ textAlign: "center", fontWeight: "600" }}
      >
        {/* ₹ {product?.productAmount} */}
        ₹ {(product?.SalePrice || 0) + ((product?.SalePrice || 0) * (product?.singleProductId?.GSTIN || 0)) / 100}

      </td>

      <td
        className={product?.isCancelled ? "redrow" : ""}
        style={{ textAlign: "center", fontWeight: "600" }}
      >
        {product?.quantity}
      </td>
      {isAdmin && (
        <td
          className={product?.isCancelled ? "redrow" : ""}
          style={{ textAlign: "center", fontWeight: "600" }}
        >
          {product?.archId?.Name ? (
            product?.archId?.Name
          ) : (
            <Button
              variant="outlined"
              color="secondary"
              size="small"
              title="click here to assign architect"
              onClick={() =>
                handleAssignArchitectClick(
                  orderProducts?._id,
                  product?._id,
                  "singleProducts"
                )
              }
            >
              Assign Architect
            </Button>
          )}
        </td>
      )}
      <td
        className={product?.isCancelled ? "redrow" : ""}
        style={{ textAlign: "right", fontWeight: "600" }}
      >
        {!isAdmin && !product?.isCancelled && (
          <Button
            onClick={() => {
              handleCancleClick(
                orderProducts?._id,
                product?._id,
                "singleProducts"
              );
            }}
            variant="contained"
            disableElevation
            color="error"
            size="small"
          >
            Cancel
          </Button>
        )}
        &nbsp;
        {!isAdmin && (
          <Button
            onClick={() => {
              setStatus(product);
              // handleOpen()
            }}
            variant="contained"
            disableElevation
            color="success"
            size="small"
            style={{ backgroundColor: "#475B52" }}
          >
            Status
          </Button>
        )}
        &nbsp;
        {isAdmin && (
          <Button
            href={`/admin/order/status/singleProducts/${orderProducts?._id}/${product?._id}`}
            variant="outlined"
            color="success"
            size="small"
          >
            Update Status
          </Button>
        )}
        &nbsp;
        {isAdmin && (
          <Button
            href={`/product/${product?.singleProductId?.Collection[0]?.url}/${
              product?.singleProductId?.Urlhandle
            }?productType=${"singleProducts"}&orderId=${
              orderProducts?._id
            }&orderItemId=${product?._id}`}
            variant="outlined"
            color={product?.isCancelled ? "primary" : "warning"}
            size="small"
          >
            View Product
          </Button>
        )}
        {product?.isCancelled && (
          <p style={{ textAlign: "left" }}>Reason : {product?.cancelReason}</p>
        )}
      </td>
    </tr>
  );
};

export default SingleProductCard;
